import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import {
	TELEMETRY_FLAGS,
	TELEMETRY_MAX_PAGE_SIZE,
	TELEMETRY_PAGE_SIZE,
	TELEMETRY_PLATFORMS,
} from '@/pages/super-admin/meeting-telemetry/meeting-telemetry.constants';
import { MeetingTelemetryPage } from '@/pages/super-admin/meeting-telemetry/MeetingTelemetryPage';

const meetingTelemetrySearchSchema = z.object({
	page: z.coerce.number().int().min(1).catch(1),
	limit: z.coerce.number().int().min(1).max(TELEMETRY_MAX_PAGE_SIZE).catch(TELEMETRY_PAGE_SIZE),
	search: z.coerce.string().optional(),
	companyId: z.string().optional(),
	from: z.string().optional(),
	to: z.string().optional(),
	flag: z.enum(TELEMETRY_FLAGS).optional(),
	platform: z.enum(TELEMETRY_PLATFORMS).optional(),
});

export const Route = createFileRoute('/_authenticated/super-admin/meeting-telemetry/')({
	component: MeetingTelemetryPage,
	validateSearch: meetingTelemetrySearchSchema,
});
